import { memo } from 'react';
import styled from 'styled-components';

import Article from '@components/Article/Article';

const Paragraph = styled.p`
  color: var(--theme-color-grey3);
  font-size: 0.9rem;
  margin-bottom: 2rem;
`;

const AffliateMessage = () => {
  return (
    <Article.ContentWrapper>
      <Paragraph>
        Please note: This article includes affiliate links. When you purchase
        qualifying products from those links we may earn a commission that helps
        support the site. As an Amazon Associate I earn from qualifying
        purchases.
      </Paragraph>
    </Article.ContentWrapper>
  );
};

export default memo(AffliateMessage);
